import React, { Component }  from "react"
import PropTypes from "prop-types"
import { StaticQuery, graphql } from "gatsby"
import { getCurrentLangKey, getLangs, getUrlForLang } from 'ptz-i18n'
import { IntlProvider } from 'react-intl'
import 'intl'

import Header from "./Header"
import '../styles/app.css'

import 'aos/dist/aos.css'

class Layout extends Component {
  render() {
    const { children, location, i18nMessages, footerComponent } = this.props
    return (
      <StaticQuery
        query={graphql`
          query SiteTitleQuery {
            site {
              siteMetadata {
                title
                languages {
                  defaultLangKey
                  langs
                }
              }
            }
          }
        `}
        render={data => {
          const url = '/' + location.pathname.split('/').slice(2).join('/')
          const { langs, defaultLangKey } = data.site.siteMetadata.languages
          const langKey = getCurrentLangKey(langs, defaultLangKey, url)
          const homeLink = `/${langKey}/`.replace(`/${defaultLangKey}`, '')
          const langsMenu = getLangs(langs, langKey, getUrlForLang(homeLink, homeLink === `/${defaultLangKey}` ? `/${defaultLangKey}${url}` : url))
            .map((item) => ({ ...item, link: item.link.replace(`/${defaultLangKey}/`, '/').replace('//', '/') }))

          return (
            <IntlProvider
              locale={langKey}
              messages={i18nMessages}
            >
              <div className="min-h-screen w-full overflow-hidden font-sans bg-gray-100 text-gray-900 font-medium">
                <Header siteTitle={data.site.siteMetadata.title}
                  locale={langKey}
                  langs={langsMenu}
                  homeLink={homeLink}
                />

                <main className="flex-auto">
                  {children}
                </main>

                { footerComponent ? footerComponent(homeLink) : null }

                <div id="modal-root" className="relative z-50"></div>
              </div>
            </IntlProvider>
          )
        }}
      />
    )
  }
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

Layout.defaultProps = {
  location: {
    pathname: '/'
  },
}

export default Layout
